import { attr, belongsTo } from 'spraypaint';

// ####### FriendshipRequestModel ################

export const FriendshipRequestModel = {
  jsonapiType: 'friendship_requests',

  attrs: {
    id: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      persist: false,
      type: 'string',
      readable: true,
      writable: false,
      description: null,
    }),
    friendId: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    message: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    name: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    token: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
  },
};

// ####### FriendshipModel ################

export const FriendshipModel = {
  jsonapiType: 'friendships',

  attrs: {
    id: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'integer_id',
      readable: true,
      writable: true,
      description: null,
    }),
    token: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: false,
      writable: true,
      description: "Création d'une amitié à partir d'un token",
    }),
    friend: belongsTo({ type: 'users' }),
  },
};

// ####### SessionModel ################

export const SessionModel = {
  jsonapiType: 'sessions',

  attrs: {
    id: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      persist: false,
      type: 'string',
      readable: true,
      writable: false,
      description: null,
    }),
    userId: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      persist: false,
      type: 'string',
      readable: true,
      writable: false,
      description: null,
    }),
    email: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: false,
      writable: true,
      description: null,
    }),
    password: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: false,
      writable: true,
      description: null,
    }),
    user: belongsTo({ type: 'users' }),
  },
};

// ####### ShareModel ################

export const ShareModel = {
  jsonapiType: 'shares',

  attrs: {
    id: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'integer_id',
      readable: true,
      writable: true,
      description: null,
    }),
    friendId: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'integer',
      readable: true,
      writable: true,
      description: null,
    }),
    upload: belongsTo({ type: 'uploads' }),
    friendship: belongsTo({ type: 'friendships' }),
  },
};

// ####### UploadModel ################

export const UploadModel = {
  jsonapiType: 'uploads',

  attrs: {
    id: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'integer_id',
      readable: true,
      writable: true,
      description: null,
    }),
    orientation: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    description: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    previewUrl: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    url: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    filename: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    contentType: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    byteSize: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    ready: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'boolean',
      readable: true,
      writable: true,
      description: null,
    }),
    metadata: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'hash',
      readable: true,
      writable: true,
      description: null,
      dirtyChecker: (a, b) => JSON.stringify(a) !== JSON.stringify(b),
    }),
    user: belongsTo({ type: 'users' }),
  },
};

// ####### UserModel ################

export const UserModel = {
  jsonapiType: 'users',

  attrs: {
    id: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'integer_id',
      readable: true,
      writable: true,
      description: null,
    }),
    email: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
    password: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: false,
      writable: true,
      description: null,
    }),
    name: attr({
      // seuls type, persist et dirtyChecker ont une utilisté pour attr()
      type: 'string',
      readable: true,
      writable: true,
      description: null,
    }),
  },
};
